import type { DistributorOrderCounts } from "@shared/types/Distributor";
import type { Distributor } from "@shared/types/Distributor";

export const compareOrderCounts = (
  d1: Distributor,
  d2: Distributor,
  distributorOrderCounts: DistributorOrderCounts
) => {
  const d1Count = distributorOrderCounts[d1.id.toString()] || 0;
  const d2Count = distributorOrderCounts[d2.id.toString()] || 0;

  if (d1Count < d2Count) return 1;
  if (d1Count > d2Count) return -1;
  return d1.name.localeCompare(d2.name)
};